<div class="mainContent">
  <div style="height: 7vh; margin-left: 10px;">
    <div>
      <label i18n="@@spmsUserReg" class="textColour" [ngStyle]="{'border-color': backgroundColorButton}">AWS Secret</label>
      <span class="example-spacer"></span>
    </div>
  </div>

  <!-- First div for Select DNS, Secret Name, and Region -->
  <div style="height: 12vh; overflow: auto; padding-left: 4%; padding-right: 4%;">
    <form novalidate [formGroup]="FormValid" style="width: 100%;">
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <div fxLayout="row" fxLayoutAlign="space-between start">
            <mat-form-field appearance="outline" fxFlex="calc(33.33% - 10px)" style="margin-right: 10px">
              <mat-label>Select DNS</mat-label>
              <mat-select placeholder="Select DNS" [(ngModel)]="selectedDns"  (selectionChange)="retriveDns($event)" formControlName="dnsId"  name="dnsId" [disabled]="isupdate" >
                <mat-option *ngFor="let dns of dnsnames" [value]="dns.id">
                  {{ dns.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngFor="let validation of validation_messages.dns">
                <span
                *ngIf="FormValid.get('dnsId').hasError(validation.type)
                && (FormValid.get('dnsId').dirty ||
                FormValid.get('dnsId').touched)">
                {{ validation.message }}
              </span>
              </mat-error>
            </mat-form-field>
  
            <!-- Add margin-right to create space -->
            <mat-form-field appearance="outline" fxFlex="calc(33.33% - 10px)" style="margin-right: 10px">
              <mat-label i18n="@@SecretName">Secret Name</mat-label>
              <input matInput [(ngModel)]="secretObj.secretName" formControlName="secretName" name="secretName" [disabled]="isupdate" required readonly>
              <mat-error *ngFor="let validation of validation_messages.secretname">
              <span
                *ngIf="FormValid.get('secretName').hasError(validation.type)
                && (FormValid.get('secretName').dirty ||
                FormValid.get('secretName').touched)">
                {{ validation.message }}
              </span>
            </mat-error>
            </mat-form-field>
             
            <!-- Add margin-right to create space -->
            <mat-form-field appearance="outline" fxFlex="calc(33.33% - 10px)">
              <mat-label i18n="@@Region">Region</mat-label>
              <input matInput [(ngModel)]="secretObj.region" formControlName="region" name="region" [disabled]="isupdate" required readonly>
              <mat-error *ngFor="let validation of validation_messages.region">
                <span
                  *ngIf="FormValid.get('region').hasError(validation.type)
                  && (FormValid.get('region').dirty ||
                  FormValid.get('region').touched)">
                  {{ validation.message }}
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
  </div>
  

  <!-- Second div for Key, Value, and Table -->
  <div style="height: 57vh; overflow: auto; padding-left: 4%; padding-right: 4%;">
    <form novalidate style="width: 100%;">
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <div>
            <div>
              <label i18n="@@spmsUserReg" class="textColour" [ngStyle]="{'border-color': backgroundColorButton}">Create Secrets</label>
              <span class="example-spacer"></span>
            </div>
          </div>
          <!-- Key and Value inputs -->
          <div fxLayout="row" fxLayoutAlign="space-between start" style="position: sticky; top: 0; background: white; z-index: 1;">
            <fieldset [disabled]="iskeyshow">
              <mat-form-field appearance="outline" fxFlex="calc(33.33% - 10px)" style="margin-right: 10px;">
                <mat-label i18n="@@SecretName">Key</mat-label>
                <input matInput [(ngModel)]="keyValueObj.key" name="key" />
              </mat-form-field>
            </fieldset>
  
            <mat-form-field appearance="outline" fxFlex="calc(33.33% - 10px)" style="margin-right: 10px;">
              <mat-label i18n="@@Region">Value</mat-label>
              <input matInput [(ngModel)]="keyValueObj.value" name="value" />
            </mat-form-field>
            <label (click)="addRecord()" style="margin-top: 6px; background: green; margin-bottom: auto; padding: 2px 5px 0px 5px; border-radius: 15px;">
              <em class="fas fa-plus" style="color: antiquewhite; font-size: large;" title="Add Secrets"></em>
            </label>
          </div>
          <!-- Table -->
         
      <div style=" overflow: auto; height: 200px; margin-top: 0px;">
        <div style="margin-top: 1%; width: 100%; ">
          <mat-toolbar
            class="agGridtopersDiv card"
            style="background: rgb(228 227 230 / 41%);
            border-top: 1px solid #a9a9a9a8;
            border-right: 1px solid #a9a9a9a8;
            border-left: 1px solid #a9a9a9a8;" >
            <label i18n="@@spmsUserReg" class="gridLabel">Secrets</label>

            <span class="example-spacer"></span>

            <div class="insertPageNoDiv">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@Targetpageno">Page No</mat-label>
                <input
                  matInput
                  type="text"
                  (input)="onSearchChange($event.target.value)"
                />
              </mat-form-field>
            </div>
            <div class="selectRecordsDiv" style="width: 9.5%">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label i18n="@@Targetrecords" style="color: black"
                >Records</mat-label
                >
                <mat-select
                  [(ngModel)]="pageSize"
                  (ngModelChange)="onPageSizeChanged()"
                >
                  <mat-option value="5" selected>5</mat-option>
                  <mat-option value="10">10</mat-option>
                  <mat-option value="300">300</mat-option>
                  <mat-option value="400">400</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div
              class="
              card
              pagination
              paginationFirstButton
              paginationFirstlastButton
            "
            >
              <em
                class="fas fa-angle-double-left waves-effect waves-light"
                (click)="onBtFirst()"
              ></em>
            </div>
            <div class="card pagination paginationButtons btn-rounded">
              <ul>
                <li class="paginationliicon">
                  <em
                    class="fas fa-angle-left waves-effect waves-light"
                    (click)="onBtPrevious()"
                  ></em>
                </li>
                <li>{{ currentPage }}/{{ totalPages }}</li>
                <li class="paginationliicon" style="padding: 0">
                  <em
                    class="fas fa-angle-right waves-effect waves-light"
                    (click)="onBtNext()"
                  ></em>
                </li>
              </ul>
            </div>
            <div
              class="
              card
              pagination
              paginationLastButton
              paginationFirstlastButton
            "
            >
              <em
                class="fas fa-angle-double-right waves-effect waves-light"
                (click)="onBtLast()"
              ></em>
            </div>
          </mat-toolbar>
        </div>
        <!-- dispatch ag-grid -->
        <ag-grid-angular class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin"
          style="height: 55vh;"
          [columnDefs]="columnDefs"
          [animateRows]="true"
          [pagination]="true"
          [rowSelection]="rowSelection"
          [defaultColDef]="defaultColDef"
          [suppressPaginationPanel]="true"
          [rowHeight]="35"
          [gridOptions]="gridOptions"
          [headerHeight]="35"
          [enableBrowserTooltips]="true"
          [floatingFiltersHeight]="45"
          [paginationPageSize]="paginationPageSize"
          [paginationNumberFormatter]="paginationNumberFormatter"
          [enableRangeSelection]="true"
          [components]="components"
          [debug]="true"
          [rowClassRules]="rowClassRules"
          (paginationChanged)="onPaginationChangedReturn()"
          (gridReady)="onGridReady($event)"
          [hidden]="!true"
                  >
        </ag-grid-angular>
      </div>

          
  
        </div>
      </div>
    </form>
  </div>
  
  </div>
  

<!-- Buttons -->
<div style="height:5vh;margin-bottom: 10px;">
  <div class="row" style= "position:sticky;left:0;bottom:0;width:100%;">

    <div class="col-lg text-center">

      <div style="text-align: end;">

        <button i18n="@@TargetClear" type="button" (click)="updateData()"
                class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
                style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">{{this.buttonName}}</button>

        <button i18n="@@TargetCancel" type="button" (click)="close()"
                class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
                style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">Cancel</button>
      </div>
    </div>
  </div>
</div>



